import web from "../../public/assets/services/web.webp";
import software from "../../public/assets/services/software.webp";
import mobile from "../../public/assets/services/mobile.webp";
import mvp from "../../public/assets/services/mvp.webp";
import ui from "../../public/assets/services/ui.webp";
import data from "../../public/assets/services/data.webp";
import cloud from "../../public/assets/services/cloud.webp";
import softwareInt from "../../public/assets/services/softwareInt.webp";

import card1 from "../../public/assets/home/card1.webp";
import card2 from "../../public/assets/home/card2.webp";
import card3 from "../../public/assets/home/card3.webp";

import core1 from "../../public/assets/services/1.webp";
import core2 from "../../public/assets/services/2.webp";
import core3 from "../../public/assets/services/3.webp";
import core4 from "../../public/assets/services/4.webp";

import aiNexusMonitor from "../../public/assets/ai-nexus/monitor.webp";

import logoMicrosoft from "../../public/assets/partners/microsoft.webp";
import logoAzure from "../../public/assets/partners/azure.webp";
import logoAws from "../../public/assets/partners/aws.webp";
import logoGoogleCloud from "../../public/assets/partners/google-cloud.webp";
import logoClaude from "../../public/assets/partners/claude.webp";
import logoClaudeLight from "../../public/assets/partners/claude-light.webp";
import logoMeta from "../../public/assets/partners/meta.webp";
import logoMetaLight from "../../public/assets/partners/meta-light.webp";
import logoAtlassian from "../../public/assets/partners/atlassian.webp";
import logoHubspot from "../../public/assets/partners/hubspot.webp";
import logoHubspotLight from "../../public/assets/partners/hubspot-light.webp";

const iconConversational = "/assets/ai-nexus/icon-conversational.svg";
const iconDashboards = "/assets/ai-nexus/icon-dashboards.svg";
const iconSparkle = "/assets/ai-nexus/icon-sparkle.svg";
const iconIncrease = "/assets/ai-nexus/icon-increase.svg";

const homeCards = [
  {
    icon: "/assets/time.svg",
    title: "Enterprise AI Strategy",
    description: "Identify where AI and data can create measurable business value.",
    key: "time",
  },
  {
    icon: "/assets/communication.svg",
    title: "Connected Intelligence",
    description:
      "Bring data across systems together for clearer, faster decisions.",
    key: "securuty",
  },
  {
    icon: "/assets/security.svg",
    title: "Responsible AI & Governance",
    description:
      "Build with security, control, transparency and accountability in mind.",
    key: "flexibility",
  },
  {
    icon: "/assets/pricing.svg",
    title: "Business-First Engineering",
    description:
      "Technology designed around real processes, users and outcomes.",
    key: "pricing",
  },
];

const expandingCardData = [
  {
    title: "Commercial Intelligence",
    description:
      "Understand sales performance, customer behavior, territory trends, and emerging growth opportunities to make data-driven decisions and drive sustainable business growth.",
    icon: card1,
  },
  {
    title: "Operations & Supply Chain Intelligence",
    description:
      "Improve visibility across operations, inventory, supply chain activities, and overall performance to identify inefficiencies, optimize resources, streamline processes, and make faster, data-driven decisions.",
    icon: card2,
  },
  {
    title: "Enterprise Decision Intelligence",
    description: "Bring data from across business functions together to provide a unified view of performance, uncover critical insights, identify emerging opportunities, and support faster, smarter, and better-informed leadership decisions.",
    icon: card3,
  },
];

const aiNexusFeatures = [
  {
    icon: iconConversational,
    title: "Conversational Intelligence",
    description:
      "Ask business questions in natural language.",
  },
  {
    icon: iconDashboards,
    title: "Executive Analytics",
    description:
      "Turn complex data into decision-ready insights.",
  },
  {
    icon: iconSparkle,
    title: "Proactive Intelligence",
    description:
      "Surface trends, risks and opportunities before they are missed.",
  },
  {
    icon: iconIncrease,
    title: "Automated Reporting",
    description:
      "Deliver the right intelligence to the right people at the right time.",
  },
];

const partnerLogos = [
  {
    name: "Microsoft",
    icon: logoMicrosoft,
    width: 980,
    height: 980,
  },
  {
    name: "Microsoft Azure",
    icon: logoAzure,
    width: 1280,
    height: 1280,
    scale: 0.667,
  },
  {
    name: "Amazon Web Services",
    icon: logoAws,
    width: 1400,
    height: 788,
  },
  {
    name: "Google Cloud",
    icon: logoGoogleCloud,
    width: 496,
    height: 497,
  },
  {
    name: "Claude",
    icon: logoClaude,
    width: 768,
    height: 768,
    lightIcon: logoClaudeLight,
    lightWidth: 600,
    lightHeight: 600,
  },
  {
    name: "Meta",
    icon: logoMeta,
    width: 734,
    height: 215,
    lightIcon: logoMetaLight,
    lightWidth: 2364,
    lightHeight: 1019,
  },
  {
    name: "Atlassian",
    icon: logoAtlassian,
    width: 447,
    height: 447,
  },
  {
    name: "HubSpot",
    icon: logoHubspot,
    width: 500,
    height: 282,
    lightIcon: logoHubspotLight,
    lightWidth: 1138,
    lightHeight: 404,
  },
];

const coreServices = [
  { icon: core1, name: "AI Assistant Solutions", alt: "AI Assistant", href: "" },
  {
    icon: core2,
    name: "Business Intelligence Systems",
    alt: "Business Intelligence",
    href: "",
  },
  {
    icon: core3,
    name: "Data Warehouse Solutions",
    alt: "Data Warehouse",
    href: "",
  },
  {
    icon: core4,
    name: "AI Workflow Automation",
    alt: "AI Workflow",
    href: "",
  },
];

const servicesData = [
  { icon: mvp, name: "MVP Development", alt: "MVP", href: "/mvp" },
  {
    icon: web,
    name: "Web Development",
    alt: "web dev",
    href: "/webApp",
  },
  {
    icon: mobile,
    name: "Mobile App Development",
    alt: "App development",
    href: "mobileApp",
  },
  { icon: ui, name: "UI/UX Design", alt: "ui/ux", href: "/uiux" },
  {
    icon: software,
    name: "Custom Software Development",
    alt: "software development",
    href: "/software-development",
  },
  {
    icon: cloud,
    name: "Cloud & DevOps",
    alt: "cloud",
    href: "/cloud",
  },
  {
    icon: data,
    name: "Machine Learning Solutions",
    alt: "Data & AI",
    href: "/data&ai",
  },
  {
    icon: softwareInt,
    name: "System Integrations",
    alt: "soft. Integration",
    href: "/software-integration",
  },
];

const ApproachData = [
  {
    title: "Business & Process Discovery",
    description:
      "Understand objectives, workflows, challenges and decision requirements.",
  },
  {
    title: "Data & AI Readiness",
    description:
      "Assess systems, data availability, quality, security and organizational readiness.",
  },
  {
    title: "Opportunity Prioritization",
    description:
      "Identify the highest-value opportunities for analytics, automation and AI.",
  },
  {
    title: "Solution Architecture",
    description:
      "Design the intelligence layer, integrations and user experience around business needs.",
  },
  {
    title: "Build & Integration",
    description:
      "Connect data, systems, analytics and AI into the operational environment.",
  },
  {
    title: "Governance & Validation",
    description:
      "Establish controls for quality, security, responsible AI and reliable decision support.",
  },
  {
    title: "Adoption & Continuous Improvement",
    description:
      "Drive user adoption, measure value and continuously improve the solution.",
  },
];

const reviews = [
  {
    name: "Lisa Chen",
    // email: "lisa@resend.com",
    title: "Founder, TechStart",
    image: "/assets/home/avatar1.webp",
    date: "Jan 14, 2025",
    stars: 5,
    review:
      "The clarity this team brought to our MVP SaaS build was incredible. They helped us shape the idea, define the core feature set, and delivered a stable, scalable first version right on schedule. The structured process and weekly updates made everything simple and predictable.",
  },
  {
    name: "Marina Gomez",
    // email: "marina@resend.com",
    title: "E-Commerce Director",
    image: "/assets/home/avatar2.webp",
    date: "Feb 2, 2025",
    stars: 5,
    review:
      "From UX to engineering, ICIEOS transformed our entire e-commerce experience. They improved the storefront, optimized performance, and implemented smart automations that boosted conversions within weeks. A reliable, detail-oriented team that truly understands retail.",
  },
  {
    name: "Andrew Blake",
    // email: "andrew@resend.com",
    title: "Founder, SoundFlow",
    image: "/assets/home/avatar3.webp",
    date: "Mar 10, 2025",
    stars: 5,
    review:
      "We needed a custom platform for creators and artists, and the ICIEOS team delivered far beyond expectations. The audio workflows, dashboards, and user tools were built with precision. Their structured communication kept everything smooth from design to launch.",
  },
  {
    name: "Paul Whitman",
    // email: "paul@resend.com",
    title: "Founder, HomeFlow",
    image: "/assets/home/avatar4.webp",
    date: "Apr 18, 2025",
    stars: 5,
    review:
      "Exceptional service and results. The team delivered beyond our expectations with creative solutions and flawless execution. Would definitely work with them again!",
  },
  {
    name: "Devin Ross",
    // email: "devin@resend.com",
    title: "Product Manager, IoTCore",
    image: "/assets/home/avatar5.webp",
    date: "May 6, 2025",
    stars: 5,
    review:
      "We worked with ICIEOS to build a real-time IoT dashboard, and the results were outstanding. The data visualization, device integrations, and backend architecture were delivered with precision. Their engineering depth and structured approach stood out immediately.",
  },
  {
    name: "Sarah Malik",
    // email: "sarah@resend.com",
    title: " Founder, OpsGen",
    image: "/assets/home/avatar6.webp",
    date: "Jun 21, 2025",
    stars: 5,
    review:
      "Our SaaS needed scaling support, performance upgrades, and new features. ICIEOS handled everything - database optimization, new modules, UI improvements, and better workflows. Their communication was clear, progress was consistent, and the product feels more solid than ever.",
  },
];

export {
  homeCards,
  expandingCardData,
  servicesData,
  ApproachData,
  reviews,
  coreServices,
  aiNexusFeatures,
  aiNexusMonitor,
  partnerLogos,
};
